var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',[_vm._v("notifications details")])
}
var staticRenderFns = []

export { render, staticRenderFns }